import { useEffect } from "react";
import { homeURL } from "../../helpers/paths";
import { useNavigate } from "react-router-dom";

const HashScroll = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleScrollToHash = () => {
      const hash = window.location.hash;

      setTimeout(() => {
        if (hash) {
          const targetId = hash.substring(1);
          const targetSection = document.getElementById(targetId);
          const headerHeight =
            document.querySelector(".header_sec")?.getBoundingClientRect()
              .height || 0;

          if (targetSection) {
            // targetSection.style.scrollMarginTop = `${headerHeight}px`;
            document.querySelectorAll("[id]").forEach((el) => {
              el.style.scrollMarginTop = `${headerHeight}px`;
            });
            console.log(`Scrolling to: ${targetId}, offset: ${headerHeight}`);

            const targetPosition =
              targetSection.getBoundingClientRect().top +
              window.scrollY -
              headerHeight;

            window.scrollTo({
              top: targetPosition,
              behavior: "smooth",
            });
            
            navigate(homeURL, { replace: true });
            console.log(`Scrolling to: ${targetId}, offset: ${headerHeight}`);
          }
        } 
        // else {
        //   window.scrollTo({ top: 0, behavior: "smooth" });
        // }
      }, 200); // Delay ensures layout stability
    };

    const handleLinkClick = (event) => {
      const anchor = event.target.closest("a[href^='#']");
      if (anchor) {
        event.preventDefault();
        const hash = anchor.getAttribute("href");

        if (hash) {
          // Force hash reset to allow re-clicks
          if (window.location.hash === hash) {
            window.history.pushState(
              "",
              document.title,
              window.location.pathname + window.location.search,
            );
          }

          window.history.pushState(null, "", hash);
          handleScrollToHash();
        }
      }
    };

    // Initial scroll on mount
    handleScrollToHash();

    // Add event listener
    document.body.addEventListener("click", handleLinkClick);

    return () => {
      document.body.removeEventListener("click", handleLinkClick);
    };
  }, [window.location.hash, navigate]);

  return null;
};

export default HashScroll;
